export const getPathnameWithLocale = (router) => {
  let path = router.pathname === "/" ? "" : router.pathname;

  if (router.defaultLocale !== router.locale) {
    path = "/" + router.locale + path;
  }

  return path;
}